const Note = () => {
  return <div>this is Note</div>
}

export default Note